/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';
import { useTranslation } from 'react-i18next';

export default function packagePeriodEnum(){
  const { t } = useTranslation();
  const trAddon = (addonType) => t(`addon.period.${addonType}`);
  return new EnumBase([
    {name: trAddon('month'), id:'month'},
    {name: trAddon('year'), id:'year'},
    {name: trAddon('semester'), id:'semester'},
  ]);
}
